export interface RolePermission {
    id: number;
    addPartner: boolean;
    viewPartner: boolean;
    editPartner: boolean;
    changePartnerStatus: boolean;
    addMerchant: boolean;
    addService: boolean;
    viewMerchant: boolean;
    editMerchant: boolean;
    cancelServices: boolean;
    changeMerchantStatus: boolean;
    unmaskPll: boolean;
    leadManagement: boolean;
    pricingAndProductManagement: boolean;
    reportingExcludingFinance: boolean;
    reportingIncludingFinance: boolean;
    stockManagement: boolean;
    viewFinance: boolean;
    viewCommissions: boolean;
    viewSelfBillingInvoices: boolean;
    addInvoice: boolean;
    addPayment: boolean;
    addCredit: boolean;
    partnerShop: boolean;
    serviceDesk: boolean;
    configurationUserManagement: boolean;
    configurationAuditLog: boolean;
    configurationFinance: boolean;
    configurationSage: boolean;
    managePartnerResources: boolean;
    configurationPartnerResources: boolean;
    configurationOther: boolean;
    customerSuccess: boolean;
    roleId: number;
}

/**
 * Check if at least one role has a specific permission
 * @param {RolePermission[]} userPermissions Array of user's role permissions
 * @param {keyof RolePermission} requiredPermission Required permission
 * @returns {boolean} Whether at least one role has the required permission
 */
export const hasPermission = (
    userPermissions: RolePermission[],
    requiredPermission: keyof RolePermission
): boolean => {
    return userPermissions?.some((role) => {
        return role[requiredPermission] === true;
    });
};

export const routePermissions: Record<string, keyof RolePermission> = {
    '/partner/add': 'addPartner',
    '/partner/:id': 'viewPartner',
    '/profile': 'viewPartner',
    '/partner/:id/edit': 'editPartner',
    '/merchant/add': 'addMerchant',
    '/merchants': 'viewMerchant',
    '/merchant/:merchantAccountNumber': 'viewMerchant',
    '/merchants/cancel': 'cancelServices',
    '/config/cancellation-reasons': 'configurationOther',
    '/config/audit-log': 'configurationAuditLog',
    '/online-pricing/add': 'pricingAndProductManagement',
    '/online-pricing/:id/edit': 'pricingAndProductManagement',
    '/products': 'pricingAndProductManagement',
    '/products/add': 'pricingAndProductManagement',
    '/products/:id/edit': 'pricingAndProductManagement',
    '/terminal-pricing/add': 'pricingAndProductManagement',
    '/terminal-pricing/:id/edit': 'pricingAndProductManagement',
    '/merchant-applications/view': 'viewMerchant',
    '/mccs/add': 'pricingAndProductManagement',
    '/mccs/:id/edit': 'pricingAndProductManagement',
    '/sales-invoices/add': 'addInvoice',
    '/finance/sales-invoices/add': 'addInvoice',
    '/finance/credits': 'addCredit',
    '/partner-shops': 'partnerShop',
    '/commissions/online': 'viewCommissions',
    '/finance/sales-invoices': 'viewFinance',
    '/commissions/terminal': 'viewCommissions',
    '/commissions/transaction': 'viewCommissions',
    '/commissions/:commissionType/:id': 'viewCommissions',
    '/user-management/users': 'configurationUserManagement',
    '/user-management/users/:id': 'configurationUserManagement',
    '/user-management/add-user': 'configurationUserManagement',
    '/user-management/user-roles': 'configurationUserManagement',
    '/user-management/add-user-role': 'configurationUserManagement',
    '/user-management/view-user-role': 'configurationUserManagement',
    '/customer-success/check-in-calls': 'customerSuccess',
};
